/*
 * View for moving a topic from the topic page
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicFolder/template/topicFolderTemplate.html",
], function (Marionette, TopicFolderTemplate) {
  var TopicFolderView = {};

  TopicFolderView.topicFolderView = Marionette.ItemView.extend({
    template: TopicFolderTemplate,
    modelEvents: {
      sync: "render",
    },
    triggers: {
      "click #topicFolderMove": "move:topic",
    },
  });

  return TopicFolderView;
});
